import { CustomerType } from "@origin-digital/platform-enums";
import { IMcAppType, NavFlow, Tab } from "../mcApp.types";

export const xeroSetup_KRAKEN: IMcAppType = {
  name: "xeroSetup_KRAKEN",
  path: "/my/xero-setup",
  description: "Xero integration setup",
  navFlow: NavFlow.FOCUS,
  title: "Xero",
  parent: Tab.MORE,

  conditions: {
    intent: "xeroSetup",
    customerType: CustomerType.kraken,
  },
};
